app.factory('Base64', function () {
    return {
        /**
         * Safely encodes a UTF-8 string to Base64, handling Unicode characters.
         * Returns original str on failure.
         */
        encode: function (str) {
            if (!str) return str;
            try {
                return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                    function toSolidBytes(match, p1) {
                        return String.fromCharCode('0x' + p1);
                    }
                ));
            } catch (e) {
                return str;
            }
        },

        /**
         * Safely decodes a Base64 string that was encoded with the above function.
         * Returns original str on failure.
         */
        decode: function (str) {
            if (!str) return str;
            try {
                return decodeURIComponent(Array.prototype.map.call(window.atob(str), function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
            } catch (e) {
                return str;
            }
        }
    };
});